export default "__VITE_ASSET__7350c6db__"